/**
 * 教师端静态菜单兜底（与 teacherStaticRouters 菜单范围一致）
 * 正常情况由 transformRouters(TEACHER_STATIC_ROUTERS) 生成
 */

export const TEACHER_STATIC_MENUS = [
  {
    path: "/home",
    meta: { title: "首页" },
    children: [
      {
        path: "",
        fullPath: "/home",
        meta: { title: "首页" }
      }
    ]
  },
  {
    path: "/course",
    meta: { title: "课程管理" },
    children: [
      {
        path: "",
        fullPath: "/course",
        meta: { title: "课程管理" }
      }
    ]
  },
  {
    path: "/question",
    meta: { title: "题库管理" },
    children: [
      {
        path: "theory",
        fullPath: "/question/theory",
        meta: { title: "理论题库" }
      },
      {
        path: "practical",
        fullPath: "/question/practical",
        meta: { title: "实操题库" }
      }
    ]
  },
  {
    path: "/Knowledge",
    meta: { title: "知识库" },
    children: [
      {
        path: "",
        fullPath: "/Knowledge",
        meta: { title: "知识库" }
      }
    ]
  },
  {
    path: "/news",
    meta: { title: "新闻管理" },
    children: [
      {
        path: "",
        fullPath: "/news",
        meta: { title: "新闻管理" }
      }
    ]
  }
];

export default TEACHER_STATIC_MENUS;



// WEBPACK FOOTER //
// ./src/config/teacherStaticMenus.js